/* eslint-disable no-console */
import { DYNAMIC_TRIGGER, PATH_IDS_PRICING_ONBOARD } from "@/contants/pricing";

export default () => ({
  computed: {
    dynamicTrigger() {
      return DYNAMIC_TRIGGER;
    },
    patIdsPricingOnboard() {
      return PATH_IDS_PRICING_ONBOARD;
    }
  }
});
